import React from 'react'

export default function Footer() {
  return (
    <div>
      <footer className="main-footer">
        <div className="pull-right hidden-xs">
        </div>
        Copyright
        &nbsp;
        <strong>
          AlbiFashion
        </strong>
        &nbsp;
        All rights reserved.
      </footer>

    </div>
  )
}